/** @format */
import { PliCbd2CollectionInterface } from '../../interfaces/collections/PliCbd2CollectionInterface';
import { PlatformResellerCollectionInterface } from '../../interfaces/collections/PlatformResellerCollectionInterface';
import { PlusOrdersCommonResponseCollectionInterface } from '../../interfaces/collections/PlusOrdersCommonResponseCollectionInterface';
import { PlusNotifyCollectionInterface } from '../../interfaces/platform/PlusNotifyInterface';
import { PlatformIpPoolNumberCollectionInterface } from '../../interfaces/platform/PlatformIpPoolNumber';
import { PlatformPoolFileCollectionInterface } from '../../interfaces/collections/PlatformPoolFilesCollectionInterface';

export const StorageReducerAction = {
    LOAD_STORAGE_HISTORY_MNP_LIST: 'LOAD_STORAGE_HISTORY_MNP_LIST',
    LOAD_STORAGE_HISTORY_PLK_LIST: 'LOAD_STORAGE_HISTORY_PLK_LIST',
    LOAD_STORAGE_HISTORY_NOTIFY_LIST: 'LOAD_STORAGE_HISTORY_NOTIFY_LIST',

    LOAD_STORAGE_HISTORY_PLATFORM_RESELLER_LIST: 'LOAD_STORAGE_HISTORY_PLATFORM_RESELLER_LIST',
    LOAD_STORAGE_HISTORY_NOP: 'LOAD_STORAGE_HISTORY_NOP',

    LOAD_CHANGE_IP_LIST_DIALOG: 'LOAD_CHANGE_IP_LIST_DIALOG',

    LOAD_MSISDN_POOL_FILE_LIST: 'LOAD_MSISDN_POOL_FILE_LIST',
    LOAD_IMSI_POOL_FILE_LIST: 'LOAD_IMSI_POOL_FILE_LIST',
    LOAD_IP_POOL_FILE_LIST: 'LOAD_IP_POOL_FILE_LIST',
};

export interface StorageReducerType {
    type: string;
    plicbd2collection?: PliCbd2CollectionInterface;
    plusOrdersCommonResponseCollection?: PlusOrdersCommonResponseCollectionInterface;
    platformResellerCollection?: PlatformResellerCollectionInterface;
    plusNotifyCollection?: PlusNotifyCollectionInterface;

    msisdnPoolList?: PlatformPoolFileCollectionInterface;
    imsiPoolList?: PlatformPoolFileCollectionInterface;
    ipPoolList?: PlatformPoolFileCollectionInterface;
}

export interface StorageReducerIpType {
    type: string;
    storageIpList?: PlatformIpPoolNumberCollectionInterface;
}

export const storageReducers = (state: any, action: StorageReducerType | StorageReducerIpType): object => {
    switch (action.type) {
        case StorageReducerAction.LOAD_STORAGE_HISTORY_MNP_LIST:
        case StorageReducerAction.LOAD_STORAGE_HISTORY_PLK_LIST:
        case StorageReducerAction.LOAD_STORAGE_HISTORY_PLATFORM_RESELLER_LIST:
        case StorageReducerAction.LOAD_STORAGE_HISTORY_NOTIFY_LIST:
        case StorageReducerAction.LOAD_MSISDN_POOL_FILE_LIST:
        case StorageReducerAction.LOAD_IMSI_POOL_FILE_LIST:
        case StorageReducerAction.LOAD_IP_POOL_FILE_LIST:
            return action;
        case StorageReducerAction.LOAD_CHANGE_IP_LIST_DIALOG:
            return {
                ...state,
                ...action,
            };
        default:
            return { ...state };
    }
};
